export default "__VITE_ASSET__DIWO6W3i__";